import axios from "axios";
import React, { useEffect, useState } from "react";
import "../../style/stuList.css";
import { Link } from "react-router-dom";
// material ui
import BlockIcon from "@mui/icons-material/Block";
import CircularProgress from "@mui/joy/CircularProgress";
import SearchBar from "material-ui-search-bar";
import Snackbar from "@mui/material/Snackbar";
import StuView from "./StuView";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { render } from "@testing-library/react";
// import BatchStuList from "./BatchStuList";
import CopyToClipboardButton from "../CopyToCliboard";

import Backdrop from "@mui/material/Backdrop";
// import Box from '@mui/material/Box';
import Modal from "@mui/material/Modal";
import Module from "./Module";
import EditModule from "./EditModule";
import { supportStuList } from "../slices/SupportStuListSlice";
import { useDispatch, useSelector } from "react-redux";
import Invoice from "./Invoice";
// import { DataGrid } from '@mui/x-data-grid';
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
export default function StuListForSupport() {
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Username, setUsername] = useState("");
  const [ProfileState, setProfileState] = useState("I");
  const [stuStatus, setstuStatus] = useState("");
  const [CourseName, setCourseName] = useState("");
  const [RegAmmt, setRegAmmt] = useState("");
  const [Education, setEducation] = useState("");
  const [Gender, setGender] = useState("");
  const [yrsOfGraduation, setyrsOfGraduation] = useState("");
  const [yrsOfExp, setyrsOfExp] = useState(0);

  const [TrainerName, setTrainerName] = useState("");
  const [PitchedAmount, setPitchedAmount] = useState("");
  const [CourseFee, setCourseFee] = useState("");
  const [NoOfInstallment, setNoOfInstallment] = useState("");
  const [InstallmentDetail, setInstallmentDetail] = useState("");
  const [PaymentDate, setPaymentDate] = useState("");
  const [ClousererName, setClousererName] = useState("");
  const [FinalFee, setFinalFee] = useState("");
  const [PhoneNo, setPhoneNo] = useState("");
  const [AllStuList, setAllStuList] = useState([]);
  const [deleteId, setdeleteId] = useState("");
  const [EditId, setEditId] = useState("");
  const [City, setCity] = useState("");
  const [LinkedIn, setLinkedIn] = useState("");
  const [Entry, setEntry] = useState();
  const [Industry, setIndustry] = useState("");
  const [Designation, setDesignation] = useState("");
  const [Discount, setDiscount] = useState("");
  const [CourseList, setCourseList] = useState([]);
  const [UserData, setUserData] = useState();
  const [CourseId, setCourseId] = useState("");
  const [BatchesList, setBatchesList] = useState([]);
  const [BatchId, setBatchId] = useState("");
  const [ListUpdate, setListUpdate] = useState(true);
  const [Modal, setModal] = useState();
  const [ProfilePic, setProfilePic] = useState("");
  const [pageNo, setpageNo] = useState(1);
  const [TotalCount, setTotalCount] = useState();
  const [ListCount, setListCount] = useState(0);
  const [listNo, setlistNo] = useState(0);
  const [IsLoading, setIsLoading] = useState(false);
  const [Search, setSearch] = useState("");
  const [open, setOpen] = React.useState(false);
  const [Installment1, setInstallment1] = useState();
  const [Installment1Status, setInstallment1Status] = useState();
  const [Installment2, setInstallment2] = useState();
  const [Installment2Status, setInstallment2Status] = useState();
  const [Installment3, setInstallment3] = useState();
  const [Installment3Status, setInstallment3Status] = useState();
  const [PaymentStatus, setPaymentStatus] = useState("");
  const [ModuleName, setModuleName] = useState("");
  const [PaymentType, setPaymentType] = useState("");
  const [View, setView] = useState("stuList");
  const [StuId, setStuId] = useState("");
  const [check, setCheck] = useState(null);
  const [clouser, setClouser] = useState({});
  const [course, setCourse] = useState({});
  const [IsFiltersActive, setIsFiltersActive] = useState(false);
  const [SortByBatch, setSortByBatch] = useState(false);
  const userGrp = JSON.parse(localStorage.getItem("user_group"));
  const name = JSON.parse(localStorage.getItem("name"));
  const [SalesUser, setSalesUser] = useState(
    userGrp.includes("G1Sales") && userGrp.length == 1 ? [name] : []
  );

  const [InstallMentStructure, setInstallMentStructure] = useState("");
  const [WelcomeStatus, setWelcomeStatus] = useState("");
  const [FilterBatch, setFilterBatch] = useState("");
  const [sort, setSort] = useState("");
  const [CourseTitle, setCourseTitle] = useState([]);
  const [ModuleList, setModuleList] = useState([]);
  const [AllModuleList, setAllModuleList] = useState([]);
  const [CheckedModules, setCheckedModules] = useState([]);
  const [Checked, setChecked] = useState({});
  const [SelectedModules, setSelectedModules] = useState([]);
  const [regType, setregType] = useState("");
  const [InvoiceId, setInvoiceId] = useState("");

  const dispatch = useDispatch();
  const { data } = useSelector((state) => state);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const status = ["A", "R", "D", "F", "O", ""];

  const handleRefreshToken = async () => {
    var formdata = new FormData();
    formdata.append("username", JSON.parse(localStorage.getItem("username")));
    formdata.append("refresh", JSON.parse(localStorage.getItem("refresh")));
    formdata.append("refresh", JSON.parse(localStorage.getItem("refresh")));
    const { data } = await axios.post("/users/token/refresh/", formdata);
    if (data.data.access) {
      localStorage.setItem("access", JSON.stringify(data.data.access));
    }
  };

  const handleGetAllStu = async () => {
    handleRefreshToken();
    setIsLoading(true);
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };

    const { data } = await axios.get(
      `/users/student/create_payment/list?page=${pageNo}&counsellor=${JSON.stringify(
        SalesUser
      )}&search=${Search}&course=[]&stud_info__student_status=${FilterBatch}&sort=${sort}`
    );

    if (data.status == "0x0") {
      setAllStuList(data?.data?.student_list.results);
      setTotalCount(data?.data?.student_list.count);
      setListCount(data?.data?.student_list.count / 10);
      setIsLoading(false);
      setSortByBatch(false);
    }
  };

  const GetAllStuByBatchEnroll = async () => {
    setIsLoading(true);
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    const { data } = await axios.get(`/users/student/create_payment/list/v1_1?page=${pageNo}`);
    if (data.status == "0x0") {
      setAllStuList(data?.data?.student_list.results);
      setTotalCount(data?.data?.student_list.count);
      setListCount(data?.data?.student_list.count / 20);
      setIsLoading(false);
      setSortByBatch(true);
    }
  };

  const handleNextPage = () => {
    if (pageNo < ListCount) {
      setpageNo((prev) => prev + 1);
      setlistNo((prev) => prev + 20);
    }
  };

  const handlePrevPage = () => {
    if (pageNo > 1) {
      setpageNo((prev) => prev - 1);
      setlistNo((prev) => prev - 20);
    }
  };

  useEffect(() => {
    if (IsFiltersActive) {
      createFilter();
    } else {
      SortByBatch ? GetAllStuByBatchEnroll() : handleGetAllStu();
    }
  }, [pageNo]);

  useEffect(() => {
    // handleGetAllStu();
    dispatch(supportStuList(pageNo, SalesUser, Search, FilterBatch, sort));
  }, []);

  useEffect(() => {
    setpageNo(1);
    setlistNo(0);
    handleGetAllStu();
  }, [FilterBatch]);

  // useEffect(() => {
  //   setpageNo(1);
  //   setlistNo(0);
  //   handleGetAllStu();
  // }, [sort]);

  const asignBatch = async () => {
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    var formdata = new FormData();
    formdata.append("batch_id", BatchId);
    formdata.append("add_students", EditId);
    // const { data } = await axios.put("/course/batch/enroll", formdata);
    const { data } = await axios.put("/course/batch/enroll/v1_1", formdata);
    if (data.status == "0x0") {
      setModal(true);
      handleGetAllStu();
      setModal(false);
      setOpen(true);
      setTimeout(() => setOpen(false), 5000);
    }
  };

  const getModuleList = async () => {
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    const { data } = await axios.get(`/course/module/course?course=${CourseId}`);
    // const { data } = await axios.get(
    //   `/course/module/list/v1_1?course_info=${CourseId}`
    // );
    if (data.status == "0x0") {
      setAllModuleList(data.data.batchData);
    }
  };

  const handleEditStu = async (e) => {
    e.preventDefault();
    // TODO: remove this handleRefreshToken
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };

    var formdata = new FormData();
    formdata.append("first_name", FirstName);
    formdata.append("last_name", LastName);
    formdata.append("email", Email);
    formdata.append("username", Email);
    formdata.append("profile_state", ProfileState);
    formdata.append("gender", Gender);
    formdata.append("phone_numbers", PhoneNo);
    formdata.append("education", Education);
    formdata.append("year_of_graduation", yrsOfGraduation);
    formdata.append("years_of_exp", yrsOfExp);
    formdata.append("current_city", City);
    formdata.append("linkedin_url", LinkedIn);
    formdata.append("entry", Entry);
    formdata.append("industry", Industry);
    formdata.append("designation", Designation);
    formdata.append("counsellor", ClousererName);
    formdata.append("student_status", stuStatus);
    // formdata.append("profilePic", "");
    formdata.append("payment_id", EditId);
    formdata.append("payment_date", PaymentDate);
    formdata.append("registration_amount", RegAmmt);
    formdata.append("final_amount", FinalFee);
    formdata.append("installment1", Installment1);
    formdata.append("installment2", Installment2);
    formdata.append("installment3", Installment3);
    formdata.append("payment_type", PaymentType);
    formdata.append("payment_status", PaymentStatus);
    // formdata.append("batch_id", "");
    formdata.append("installment1_status", Installment1Status);
    formdata.append("installment2_status", Installment2Status);
    formdata.append("installment3_status", Installment3Status);
    formdata.append("installment_structure", InstallMentStructure);
    formdata.append("discount", Discount);
    formdata.append("pitched_amount", PitchedAmount);
    formdata.append("welcome_call_status", WelcomeStatus);
    formdata.append("add_modules", JSON.stringify(SelectedModules));
    formdata.append("registration_type", "L");

    // const { data } = await axios.put("/users/student/profile/", formdata);

    const { data } = await axios.put("/users/student/create_payment/v1_2", formdata);

    if (BatchId != "") {
      asignBatch();
    }

    if (data.status == "0x0") {
      handleGetAllStu();
    }
  };

  const getStuProfile = async () => {
    handleRefreshToken();
    const { data } = await axios.get(`/users/student/create_payment?payment_id=${EditId}`);

    if (data.status == "0x0") {
      setUserData(data?.data?.userData);
      setFirstName(data?.data?.userData.first_name);
      setLastName(data?.data?.userData.last_name);
      setEmail(data?.data?.userData.username);
      setUsername(data?.data?.userData.username);
      setProfileState(data?.data?.userData.profile_state);
      setstuStatus(data?.data?.userData.student_status);
      setGender(data?.data?.userData.gender);
      setPhoneNo(data?.data?.userData.phone_numbers);
      setEducation(data?.data?.userData.education);
      setyrsOfGraduation(data?.data?.userData.yr_of_graduation);
      setyrsOfExp(data?.data?.userData.yrs_of_exp);
      setCity(data?.data?.userData.current_city);
      setLinkedIn(data?.data?.userData.linkedin_url);
      // setEmail(data?.data?.userData.email)
      setEntry(
        data?.data?.userData.registration_date === null
          ? ""
          : data?.data?.userData.registration_date
      );
      setIndustry(data?.data?.userData.industry);
      setDesignation(data?.data?.userData.designation);
      setClousererName(data?.data?.userData.counsellor);
      // setEmail(data?.data?.userData.payment_date)
      setPaymentDate(data?.data?.userData.payment_date);
      setRegAmmt(data?.data?.userData.registration_amount);
      setPitchedAmount(data?.data?.userData.pitched_amount);
      setDiscount(data?.data?.userData.discount);
      setFinalFee(data?.data?.userData.final_amount);
      setPaymentDate(data?.data?.userData.payment_date);
      setRegAmmt(data?.data?.userData.registration_amount);
      // setFinalFee(data?.data?.userData.final_amount);
      setInstallment1(data?.data?.userData.installment1);
      setInstallment2(data?.data?.userData.installment2);
      setInstallment3(data?.data?.userData.installment3);
      setPaymentType(data?.data?.userData.payment_type);
      setPaymentStatus(data?.data?.userData.payment_status);
      setInstallment1Status(data?.data?.userData.installment1_status);
      setInstallment2Status(data?.data?.userData.installment2_status);
      setInstallment3Status(data?.data?.userData.installment3_status);
      setInstallMentStructure(data?.data?.userData.installment_structure);
      setWelcomeStatus(data?.data?.userData.welcome_call_status);
      // setAllModuleList(data?.data?.userData.modules)
      setChecked(data?.data?.userData.modules_id);
      setSelectedModules(data?.data?.userData.modules_id);
      setregType(data?.data?.userData.registration_type);
      setBatchId("");
      setCourseId("");
      // setCourseList([])
      setBatchesList([]);
    }
  };

  const handleGetAllCourse = async () => {
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };

    // const { data } = await axios.get("/course/course/list");

    const { data } = await axios.get("/course/course/");
    setCourseList(data?.data?.courseDetails);
  };

  const GetAllBatchesByCourse = async () => {
    var formdata = new FormData();
    // formdata.append("course_info", );

    // const { data } = await axios.get(
    //   `/course/batch/list?course_info__title=${CourseId}`
    // );

    const { data } = await axios.get(`/course/batch/course?course=${CourseId}`);
    // setBatchesList(data.data.batch_list.results);
    setBatchesList(data.data.batchData);
    // console.log(data.data.batch_list.results);
  };

  useEffect(() => {
    if (CourseId != "") {
      GetAllBatchesByCourse();
      getModuleList();
    }
  }, [CourseId]);

  useEffect(() => {
    getStuProfile();
    handleGetAllCourse();
  }, [EditId]);

  const ActiveDeactivate = async (id, isActive) => {
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    var formdata = new FormData();
    if (isActive) {
      formdata.append("id", id);
      formdata.append("is_active", "False");
      const { data } = await axios.post(`/users/student/profile/deactivate`, formdata);

      if ((data.data.status = "0x0")) {
        handleGetAllStu();
      }
    } else {
      formdata.append("id", id);
      formdata.append("is_active", "True");
      const { data } = await axios.post(`/users/student/profile/reactivate`, formdata);
      if ((data.data.status = "0x0")) {
        handleGetAllStu();
      }
    }
  };

  const handleSearch = async () => {
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };

    // const { data } = await axios.get(`/users/student/list/?search=${Search}`);
    // const { data } = await axios.get(
    //   `/users/student/create_payment/list?search=${Search}&sort=${sort}`
    // );

    const { data } = await axios.get(
      `/users/student/create_payment/list?page=${pageNo}&search=${Search}&counsellor=${JSON.stringify(
        SalesUser
      )}&course=${JSON.stringify(CourseTitle)}&sort=${sort}`
    );

    if (data.status == "0x0") {
      setAllStuList(data?.data?.student_list.results);
      setTotalCount(data?.data?.student_list.count);
      setListCount(data?.data?.student_list.count / 10);
      // setIsLoading(false)
    }
  };

  useEffect(() => {
    handleSearch();
  }, [Search]);

  const handleView = (id) => {
    setStuId(id);
    setView("StuView");
  };

  const clousers = [
    "Gaurav",
    "Shubhankar",
    "Tanya",
    "Rahul",
    "Aman",
    "Himanshu",
    "Renuka",
    "Sourav",
    "Trapti",
    "Dinisha",
    "Rituraj",
    "Pratik",
    "Rahul D",
    "Smita",
    "Rishab",
    "Pragati",
    "Nirmal",
    "Prem",
    "Shreyas",
    "Sachin",
    "Vedant",
    "Anjali",
  ];

  const handleClouserFilter = (event) => {
    const testClouser = {
      ...clouser,
      [event.target.name]: event.target.checked,
    };
    setClouser(testClouser);
  };

  const handleCourseFilter = (event) => {
    const testCourse = {
      ...course,
      [event.target.name]: event.target.checked,
    };
    setCourse(testCourse);
  };

  const createFilter = async () => {
    // e.preventDefault();
    handleRefreshToken();
    const token = JSON.parse(localStorage.getItem("access"));
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
    const Clouser = [];
    Object.entries(clouser).map((key, value) => {
      if (key[1]) Clouser.push(key[0]);
    });

    const Course = [];
    Object.entries(course).map((key, value) => {
      if (key[1]) Course.push(key[0]);
    });
    const { data } = await axios.get(
      `/users/student/create_payment/list?course=${JSON.stringify(
        Course
      )}&counsellor=${JSON.stringify(Clouser)}&page=${pageNo}&sort=${sort}`
    );

    // const { data } = await axios.get(
    //   `/users/student/filter/course/?course_name=${JSON.stringify(
    //     Course
    //   )}&counsellor=${JSON.stringify(Clouser)}&page=${pageNo}&sort=${sort}`
    // );

    if (data.status == "0x0") {
      setAllStuList(data?.data?.student_list.results);
      setTotalCount(data?.data?.student_list.count);
      setListCount(data?.data?.student_list.count / 10);
      setIsLoading(false);
      if (Clouser.length == 0 && Course == 0) {
        setIsFiltersActive(false);
      } else {
        setIsFiltersActive(true);
      }
    }
    // if (data.status == "0x0") {
    //   setAllStuList(data?.data?.userData.results);
    //   setTotalCount(data?.data?.userData.count);
    //   setListCount(data?.data?.userData.count / 10);
    //   setIsLoading(false);
    //   if (Clouser.length == 0 && Course == 0) {
    //     setIsFiltersActive(false);
    //   } else {
    //     setIsFiltersActive(true);
    //   }
    // }
  };

  const handleChange = (id, name) => (event) => {
    // const test = {
    //   ...Checked,
    //   [id]: event.target.checked,
    // };
    // setChecked(test);

    if (event.target.checked) {
      setSelectedModules((prevSelected) => [...prevSelected, id]);
    } else {
      setSelectedModules((prevSelected) => prevSelected.filter((moduleId) => moduleId !== id));
    }
  };

  // const resetFilters=()=>{
  //   setClouser({});
  //   setCourse({});
  // }

  return (
    <div className="">
      {/* ============ student List ============*/}
      <Snackbar
        open={open}
        className="w-75"
        // autoHideDuration={3000}
        // onClose={handleClose}
        message="Batch Enrolled successfully...!!!"
        // action={action}
        sx={{
          bgcolor: "info",
        }}
      />
      <h4 className="mb-4">Student List</h4>

      {IsLoading ? (
        <div className="d-flex justify-content-center align-items-center flex-column  w-100 h-100">
          <CircularProgress size="lg" />
        </div>
      ) : (
        <>
          {View == "stuList" ? (
            <>
              <div className="row my-3 ms-3">
                <div className="col-10">
                  <SearchBar
                    value={Search}
                    onChange={(newValue) => setSearch(newValue)}
                    onCancelSearch={(newValue) => setSearch("")}
                    style={{ padding: "-10px" }}
                  />
                </div>

                <div className="col-2">
                  <button
                    className="btn btn-info btn-lg"
                    data-bs-target="#ClouserFilterModal"
                    data-bs-toggle="modal"
                  >
                    Filters <i className="ms-1 bi bi-funnel"></i>
                  </button>
                </div>
              </div>

              {/*========== stuList ============= */}

              <div className="table table-responsive mt-2">
                <table className="table table-bordered custom-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th className="text-center  ">
                        <p className="srNo">Sr. No.</p>
                      </th>
                      <th className="supportTable">
                        <div className="dropdown supportTable">
                          <p
                            className="dropdown-toggle supportTable"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Name
                          </p>
                          <ul className="dropdown-menu">
                            <li style={{ cursor: "pointer" }} onClick={GetAllStuByBatchEnroll}>
                              <span className="dropdown-item">Sort By Batch Enroll</span>
                            </li>
                            <li style={{ cursor: "pointer" }} onClick={handleGetAllStu}>
                              <span className="dropdown-item">Sort By Recently Added</span>
                            </li>
                          </ul>
                        </div>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">BatchId</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Registration date</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Total Enrolled Batches </p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Email (Username)</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Course</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Module Name</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Phone No.</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Total Fees</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Reg. Amount</p>
                      </th>

                      <th className="supportTable">
                        <p className="supportTable">Fees Bal.</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Last payment Date</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">OnBoarding Process</p>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Closurer</p>
                      </th>
                      <th className="supportTable">
                        <div className="dropdown">
                          <p
                            className="dropdown-toggle"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Students Status
                          </p>
                          <ul className="dropdown-menu">
                            {status.map((sts, i) => (
                              <li
                                style={{ cursor: "pointer" }}
                                key={i}
                                onClick={() => setFilterBatch(sts)}
                              >
                                <span className="dropdown-item">
                                  {sts == "" && "All Students"}
                                  {sts == "R" && "Refunded"} {sts == "D" && "Drop Out"}
                                  {sts == "A" && "Active"}
                                  {sts == "O" && "Only registered"}
                                  {sts == "F" && "Asking for refund"}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </th>
                      <th className="supportTable">
                        <p className="supportTable">Actions</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {AllStuList.length == 0 ? (
                      <h4 className="text-center my-2">No Results Found</h4>
                    ) : (
                      <>
                        {AllStuList.map((item, i) => (
                          <tr key={i} className="p-0 m-0">
                            <td>{i + 1 + listNo}</td>
                            <td>
                              {item?.first_name} {item?.last_name}
                            </td>
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() => handleView(item?.payment_id)}
                            >
                              {item?.batch_Id == null ? "----" : item?.batch_Id}
                              {item?.batch_count > 1 && "..."}
                            </td>
                            <td>{item?.registration_date}</td>
                            <td>{item?.batch_count == null ? "0" : item?.batch_count}</td>
                            <td>{item?.username}</td>
                            <td>{item?.course == null ? "----" : item?.course}</td>
                            <td
                              style={{ cursor: "pointer" }}
                              data-bs-target="#modules"
                              data-bs-toggle="modal"
                              onClick={() => setModuleList(item.modules)}
                            >
                              {item.modules.length > 1
                                ? item.modules[0] + "..."
                                : item.modules.length === 0
                                ? "---"
                                : item.modules[0]}
                            </td>
                            <td>{item?.phone_numbers}</td>
                            <td>{item?.final_amount}</td>
                            <td>{item?.registration_amount}</td>
                            <td>{item?.remaining_amount}</td>

                            {/* <td>
                              {Math.round(
                                item?.final_amount -
                                  item?.registration_amount -
                                  (item?.installment1_status == "P"
                                    ? item?.installment1
                                    : 0) -
                                  (item?.installment2_status == "P"
                                    ? item?.installment2
                                    : 0) -
                                  (item?.installment3_status == "P"
                                    ? item?.installment3
                                    : 0)
                              )}
                            </td> */}
                            <td>{item?.payment_date}</td>
                            <td>
                              {item?.welcome_call_status == null && "N"}
                              {item?.welcome_call_status}
                            </td>
                            <td>{item?.counsellor}</td>
                            <td>
                              {item?.student_status == "" && "All students"}
                              {item?.student_status == "R" && "Refunded"}{" "}
                              {item?.student_status == "D" && "Drop Out"}
                              {item?.student_status == "A" && "Active"}
                              {item?.student_status == "O" && "Only registered"}
                              {item?.student_status == "F" && "Asking for refund"}
                            </td>
                            <td className="d-flex justify-content-center">
                              {/* <span> */}
                              <BlockIcon
                                className={item?.is_active ? "text-info" : "text-danger"}
                                style={{ cursor: "pointer" }}
                                onClick={() => ActiveDeactivate(item?.payment_id, item?.is_active)}
                              />

                              {/* </span> */}

                              <button
                                className="btn btn-info btn-sm mx-1"
                                data-bs-toggle="modal"
                                data-bs-target="#editStuModal"
                                onClick={() => setEditId(item?.payment_id)}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              <button
                                className="btn btn-info btn-sm"
                                onClick={() => setInvoiceId(item?.payment_id)}
                              >
                                <i class="bi bi-receipt"></i>
                              </button>

                              {/* <button
                                className="btn btn-info btn-sm mx-1"
                                onClick={() => handleView(item?.payment_id)}
                              >
                                View
                              </button> */}
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>

              {/*============= pagination ============= */}

              <div className="container d-flex justify-content-between my-5">
                <button className="btn btn-info mb-5" onClick={handlePrevPage}>
                  Prev
                </button>

                <button className="btn btn-info mb-5" onClick={handleNextPage}>
                  Next
                </button>
              </div>
            </>
          ) : (
            <>
              <h2 style={{ cursor: "pointer" }} onClick={() => setView("stuList")}>
                <i className="bi bi-arrow-left-circle-fill"></i>
              </h2>
              <StuView StuId={StuId} />
            </>
          )}
        </>
      )}

      {/* ============ edit student =========== */}

      <div
        className="modal fade"
        id="editStuModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Student
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-10 offset-1 mb-4">
                  <form onSubmit={handleEditStu}>
                    <div className="row py-4">
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">First Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setFirstName(e.target.value)}
                          value={FirstName}
                          placeholder="First Name"
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Last Name:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setLastName(e.target.value)}
                          value={LastName}
                          placeholder="Last Name"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Email:</label>
                        <input
                          type="Email"
                          className="form-control"
                          onChange={(e) => setEmail(e.target.value)}
                          value={Email}
                          placeholder="Email"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Phone No.:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setPhoneNo(e.target.value)}
                          value={PhoneNo}
                          placeholder="Phone No."
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Registration Type:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setregType(e.target.value)}
                          value={regType}
                          placeholder="Gender"
                          required
                        >
                          <option value="" selected>
                            Select Registration Type
                          </option>
                          <option value="L">Live Learning</option>
                          <option value="R">Recordings Only</option>
                          <option value="J">Job Assistance Only</option>
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Profile State:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setProfileState(e.target.value)}
                          value={ProfileState}
                          aria-label="Profile Status"
                        >
                          <option value="I">Incomplete</option>
                          <option value="C">Complete</option>
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Students Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setstuStatus(e.target.value)}
                          value={stuStatus}
                          aria-label="Profile Status"
                        >
                          <option value="A">Active</option>
                          <option value="R">Refunded</option>
                          <option value="D">Drop Out</option>
                          <option value="F">Asking for refund</option>
                          <option value="O">Only registered</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Education:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setEducation(e.target.value)}
                          value={Education}
                          placeholder="Education"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Gender:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setGender(e.target.value)}
                          value={Gender}
                          placeholder="Gender"
                        >
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">yrs of Graduation:</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setyrsOfGraduation(e.target.value)}
                          value={yrsOfGraduation}
                          placeholder="yrs of Graduation"
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">yrs of Exp:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setyrsOfExp(e.target.value)}
                          value={yrsOfExp}
                          placeholder="yrs of Exp"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">City:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setCity(e.target.value)}
                          value={City}
                          placeholder="City"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">LinkedIn URL:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setLinkedIn(e.target.value)}
                          value={LinkedIn}
                          placeholder="LinkedIn URL"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Registration Date:</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setEntry(e.target.value)}
                          value={Entry}
                          placeholder="Registration Date"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Industry:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setIndustry(e.target.value)}
                          value={Industry}
                          placeholder="Industry"
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Designation:</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setDesignation(e.target.value)}
                          value={Designation}
                          placeholder="Designation"
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Name of Clouserer:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setClousererName(e.target.value)}
                          value={ClousererName}
                          placeholder="Gender"
                        >
                          {clousers.map((clouser, i) => (
                            <option value={clouser} key={i}>
                              {clouser}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* payment fields  */}

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Onboarding Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setWelcomeStatus(e.target.value)}
                          value={WelcomeStatus}
                          aria-label="Profile Status"
                        >
                          <option selected>Welcome mail status</option>
                          <option value="Y">Yes</option>
                          <option value="N">No</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Reg Amount:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setRegAmmt(e.target.value)}
                          placeholder="Reg Amount"
                          value={RegAmmt}
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Final Amount:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setFinalFee(e.target.value)}
                          placeholder="Reg Amount"
                          value={FinalFee}
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Pitched Amount:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setPitchedAmount(e.target.value)}
                          placeholder="Pitched Amount"
                          value={PitchedAmount}
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Discount Amount:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setDiscount(e.target.value)}
                          placeholder="Discount Amount"
                          value={Discount}
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">installment1:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setInstallment1(e.target.value)}
                          placeholder="installment1"
                          value={Installment1}
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Installment1 Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setInstallment1Status(e.target.value)}
                          value={Installment1Status}
                          aria-label="Profile Status"
                        >
                          <option selected>Select installment status</option>
                          <option value="P">Paid</option>
                          <option value="U">Unpaid</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">installment2:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setInstallment2(e.target.value)}
                          placeholder="installment2"
                          value={Installment2}
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Installment2 Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setInstallment2Status(e.target.value)}
                          value={Installment2Status}
                          aria-label="Profile Status"
                        >
                          <option selected>Select installment status</option>
                          <option value="P">Paid</option>
                          <option value="U">Unpaid</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">installment3:</label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setInstallment3(e.target.value)}
                          placeholder="installment3"
                          value={Installment3}
                        />
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Installment3 Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setInstallment3Status(e.target.value)}
                          value={Installment3Status}
                          aria-label="Profile Status"
                        >
                          <option selected>Select installment status</option>
                          <option value="P">Paid</option>
                          <option value="U">Unpaid</option>
                        </select>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Payment Type:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setPaymentType(e.target.value)}
                          aria-label="Profile Status"
                          value={PaymentType}
                          required
                        >
                          <option selected>Select payment Type</option>
                          <option value="I">Installment</option>
                          <option value="F">Full Payment</option>
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Payment Status:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setPaymentStatus(e.target.value)}
                          aria-label="Payment Status"
                          value={PaymentStatus}
                        >
                          <option>Select Payment Status</option>
                          <option value="C">Complete</option>
                          <option value="I">Incomplete</option>
                          <option value="P">Partial Payment</option>
                          {/* <option value="D">Payment Due</option> */}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Payment Date:</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setPaymentDate(e.target.value)}
                          placeholder="Payment Date"
                          value={PaymentDate}
                        />
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Remark:</label>
                        <textarea
                          name=""
                          id=""
                          cols="30"
                          rows="1"
                          className="form-control"
                          onChange={(e) => setInstallMentStructure(e.target.value)}
                          value={InstallMentStructure}
                          placeholder="InstallMentStructure"
                        ></textarea>
                      </div>
                      {/* <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Select Module:</label>
                        <select
                          className="form-select"
                          name="UserRole"
                          onChange={(e) => setModuleName(e.target.value)}
                          aria-label="ModuleName"
                          value={ModuleName}
                        >
                             <option value="">Select Module</option>
                          {AllModuleList.map((module,i)=>(
                            <option key={i} value="">{module.title}</option>
                          ))}
                        </select>
                      </div> */}

                      {/* enroll batch  */}

                      <hr />
                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Course Name:</label>
                        <select
                          className="form-select"
                          onChange={(e) => setCourseId(e.target.value)}
                        >
                          <option value="" selected>
                            Select Course
                          </option>
                          {CourseList?.map((item, i) => (
                            <option className="text-dark" value={item.title} key={i}>
                              {item.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 my-2">
                        <div
                          className="btn-light btn w-100 mt-4"
                          data-bs-target="#ModalOfModule"
                          data-bs-toggle="modal"
                        >
                          Select Modules
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 my-2">
                        <label htmlFor="">Batch Id:</label>
                        <select
                          className="form-select"
                          onChange={(e) => setBatchId(e.target.value)}
                        >
                          <option value="" selected>
                            Select Batch
                          </option>
                          {BatchesList?.map((item, i) => (
                            // <option
                            //   className="text-dark"
                            //   value={item?.batch_id}
                            //   key={i}
                            // >
                            //   {item?.user_batch_id}
                            // </option>
                            <option className="text-dark" value={item?.user_batch_id} key={i}>
                              {item?.user_batch_id}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="d-flex justify-content-end my-2">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                          Close
                        </button>
                        <button
                          className="btn btn-primary ms-2"
                          data-bs-dismiss={Modal ? "" : "modal"}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* filter modal */}

      <div
        className="modal fade"
        id="ClouserFilterModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Apply filters
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-3">
                  <h6>Filter By Clouser</h6>
                  <FormGroup>
                    {clousers.map((clouser, i) => (
                      <FormControlLabel
                        control={<Checkbox onChange={handleClouserFilter} name={clouser} />}
                        label={clouser}
                        key={i}
                      />
                    ))}
                  </FormGroup>
                </div>
                <div className="col-6">
                  <h6>Filter By Course</h6>
                  <FormGroup>
                    {CourseList.map((Course, i) => (
                      <FormControlLabel
                        control={<Checkbox onChange={handleCourseFilter} name={Course.title} />}
                        label={Course.title}
                        key={i}
                      />
                    ))}
                  </FormGroup>
                </div>
                <div className="col-3">
                  <h6>Filter By Fees Balance</h6>
                  <select className="form-select" onChange={(e) => setSort(e.target.value)}>
                    <option value="" selected>
                      Select Option
                    </option>
                    <option value="D">Descending</option>
                    <option value="A">Ascending</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-12 my-4 d-flex justify-content-end">
                {/* <button
                  className="btn btn-primary me-2"
                  // data-bs-dismiss="modal"
                  onClick={resetFilters}
                >
                  Reset
                </button> */}

                <button className="btn btn-primary" data-bs-dismiss="modal" onClick={createFilter}>
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Module ModuleList={ModuleList} />
      {/* module edit*/}
      <div
        class="modal fade"
        id="ModalOfModule"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Select Module
              </h5>
            </div>

            <div class="modal-body">
              <FormGroup>
                {AllModuleList.map((module, i) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleChange(module.id, module.title)}
                        name={module.id}
                        // defaultChecked ={CoachArr.includes(coach.id)?true:false}
                        // checked={CheckedModules[module.3id]}
                      />
                    }
                    label={module.title}
                    key={i}
                  />
                ))}
              </FormGroup>
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Component  */}

      <Invoice invoiceId={InvoiceId} />
    </div>
  );
}
